/**
 * Unified App Layout Component
 * 
 * Provides consistent layout structure across all pages, eliminating
 * the need for each page to implement layout from scratch.
 * 
 * Features:
 * - Responsive flex layout
 * - Optional custom sidebar
 * - Consistent background and structure
 * - Eliminates ml-[250px] anti-pattern
 */

import React from 'react';
import { SimplifiedSidebar } from './simplified-sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  className?: string;
}

export const AppLayout = ({ 
  children, 
  sidebar, 
  className = "" 
}: AppLayoutProps) => {
  return (
    <div className={`flex min-h-screen bg-brand-background ${className}`}>
      {sidebar ?? <SimplifiedSidebar />}
      <div className="flex-1 flex flex-col min-h-screen">
        {children}
      </div>
    </div>
  );
};
















